// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".MultiPaperModal-cls1__fc99bec993615cf63a0e{/*!*/}.MultiPaperModal-cls2___bbb32906e7e9bb19ed1{}.MultiPaperModal-cls2___bbb32906e7e9bb19ed1>*{border-radius:8px;border-radius:var(--corner-radius-radius-md, 8px)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "MultiPaperModal-cls1__fc99bec993615cf63a0e",
	"cls2": "MultiPaperModal-cls2___bbb32906e7e9bb19ed1 MultiPaperModal-cls1__fc99bec993615cf63a0e"
};
export default ___CSS_LOADER_EXPORT___;
